'use client';

import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { cn } from '@/lib/utils';

export function ErvAttendanceSimulationSkeleton() {
  const s = useCadrinoCopy().attendanceSimulation;

  return (
    <div
      className="rounded-xl bg-white text-gray-900 shadow-inner ring-1 ring-black/5"
      aria-hidden
    >
      <div className="border-b border-gray-100 px-4 py-4 sm:px-6 sm:py-5">
        <div className="h-3 w-28 animate-pulse rounded bg-gray-200" />
        <div className="mt-3 h-7 w-64 max-w-full animate-pulse rounded bg-gray-200" />
        <div className="mt-2 h-4 w-80 max-w-full animate-pulse rounded bg-gray-100" />
      </div>
      <div className="space-y-6 p-4 sm:p-6">
        <div className="grid grid-cols-2 gap-4 xl:grid-cols-5">
          {Array.from({ length: 5 }).map((_, i) => (
            <div key={i} className="h-24 animate-pulse rounded-xl border border-gray-100 bg-gray-50" />
          ))}
        </div>
        <div className="h-32 animate-pulse rounded-xl border border-gray-100 bg-gray-50" />
        <div className="space-y-2">
          <div className="h-5 w-48 animate-pulse rounded bg-gray-200" />
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              className={cn('h-12 animate-pulse rounded-md bg-gray-100', i === 0 && 'bg-gray-200')}
            />
          ))}
        </div>
      </div>
      <span className="sr-only">{s.pageTitle}</span>
    </div>
  );
}
